import React from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';
import { TicketIcon, MagnifyingGlassIcon, GavelIcon } from './IconComponents';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenContactModal: (subject?: string) => void;
}

const CollaborationCard: React.FC<React.PropsWithChildren<{
    icon: React.ReactNode;
    title: string;
}>> = ({ icon, title, children }) => (
    <div className="flex flex-col p-6 bg-white rounded-xl shadow-md border border-gray-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 h-full">
        <div className="flex-shrink-0 mb-4">
            <div className="flex items-center justify-center h-14 w-14 rounded-full bg-blue-100 text-blue-600">
                {icon}
            </div>
        </div>
        <h3 className="text-xl font-bold text-gray-800 mb-3">{title}</h3>
        <div className="text-gray-600 text-sm leading-relaxed space-y-2">{children}</div>
    </div>
);


export const PartnersModal: React.FC<ModalProps> = ({ isOpen, onClose, onOpenContactModal }) => {
  const handleContactClick = () => {
    onClose();
    onOpenContactModal('Interesado en ser Partner');
  };

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      title="Colabora con Nosotros: Área de Partners"
      containerClassName="max-w-5xl"
      mainClassName="bg-gray-50"
    >
      <div className="text-center px-4">
        <h2 className="text-3xl font-bold text-gray-800">Conviértete en nuestro próximo partner estratégico.</h2>
        <p className="text-lg text-gray-600 mt-3 mb-10 max-w-3xl mx-auto">
          Actuamos como un concentrador de casos. Gracias a nuestra popularidad y conocimiento, los afectados acuden a nosotros. Buscamos a los mejores profesionales para asignárselos, previa negociación de condiciones con el cliente.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        <CollaborationCard
            icon={<TicketIcon className="w-8 h-8" />}
            title="Tema Multas"
        >
            <p>El cliente paga una cantidad fija mensual, generando un procedimiento automático gestionado por nuestros agentes locales.</p>
            <p>Si el caso escala, se asigna un abogado de nuestra red, quien cobra la cantidad previamente pactada para la intervención.</p>
        </CollaborationCard>
        <CollaborationCard
            icon={<MagnifyingGlassIcon className="w-8 h-8" />}
            title="Tema Pericial"
        >
           <p>Estudiamos la viabilidad de cada caso. En función del análisis, decidimos si actuar <strong className="font-semibold text-gray-800">PRO-BONO (a éxito)</strong> o con un precio fijado por el profesional.</p>
            <p>Tú, como experto, tienes la última palabra en la valoración del servicio.</p>
        </CollaborationCard>
        <CollaborationCard
            icon={<GavelIcon className="w-8 h-8" />}
            title="Tema Judicial"
        >
            <p>Nuestro modelo es similar al turno de oficio de los colegios profesionales, pero con una diferencia clave: <strong className="font-semibold text-gray-800">filtramos los casos</strong>.</p>
            <p>Solo aceptamos y asignamos casos que, tras un estudio previo, demuestran tener altas probabilidades de éxito, garantizando un trabajo más eficiente y gratificante.</p>
        </CollaborationCard>
      </div>

       <div className="mt-12 pt-8 border-t border-gray-200 text-center bg-blue-50/50 p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-blue-800">¿Interesado en unirte a nuestra red de éxito?</h3>
            <p className="mt-3 text-gray-700 max-w-2xl mx-auto">
                Si eres un profesional del derecho o un perito experto y buscas un flujo constante de casos interesantes y viables, queremos conocerte.
            </p>
            <div className="mt-6">
                <Button onClick={handleContactClick} variant="primary" size="large">
                    Quiero ser Partner
                </Button>
            </div>
        </div>
    </ModalBase>
  );
};
